import BrandWordmark from './BrandWordmark';
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LINKS = [
  { to: '/ozellikler', label: 'Özellikler' },
  { to: '/hakkimizda', label: 'Hakkımızda' },
  { to: '/fiyatlar', label: 'Fiyatlar' },
  { to: '/blog', label: 'Blog' },
  { to: '/iletisim', label: 'İletişim' },
  { to: '/demo', label: 'Demo Al' },
];

const Footer = () => (
  <footer className="bg-ink-strong text-white">
    <div className="container mx-auto px-4 pb-7 pt-12 sm:pt-16">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.5fr_1fr]">
        <div>
          <div className="mb-4 flex items-center gap-2.5">
            <img src="/favicon.svg" alt="Tilki Otomasyon" width="32" height="32" className="h-8 w-8" />
            <BrandWordmark />
          </div>

          <p className="mb-6 max-w-md font-inter leading-relaxed text-white/60">
            Restoran, kafe, bar ve pub gibi işletmeler için özel olarak tasarlanmış kapsamlı otomasyon platformu.
          </p>

          <ul className="flex flex-col gap-3 font-inter">
            <li className="flex items-center gap-3 text-white/70">
              <Phone size={16} className="flex-shrink-0 text-brand-400" aria-hidden="true" />
              <a href="tel:+905422545535" className="text-white/70 hover:text-white">
                +90 542 254 55 35
              </a>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <Mail size={16} className="flex-shrink-0 text-brand-400" aria-hidden="true" />
              <a href="mailto:iletisim@tilkiotomasyon.com" className="break-all text-white/70 hover:text-white">
                iletisim@tilkiotomasyon.com
              </a>
            </li>
            <li className="flex items-center gap-3 text-white/70">
              <MapPin size={16} className="flex-shrink-0 text-brand-400" aria-hidden="true" />
              <span>İstanbul, Türkiye</span>
            </li>
          </ul>
        </div>

        <nav>
          <h4 className="mb-4 font-inter text-xs font-semibold uppercase tracking-[0.12em] text-white/50">Şirket</h4>
          <ul className="flex flex-col gap-3 font-inter">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/75 hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="mt-12 border-t border-white/10 pt-6 font-inter text-sm text-white/50">
        © {new Date().getFullYear()} Tilki Otomasyon. Tüm hakları saklıdır.
      </div>
    </div>
  </footer>
);

export default Footer;
